// Install panel — DESKTOP tab: platform picker + primary download button.
import { useState } from "react";
import styles from "../Connect.module.css";
import PlatformOption from "./PlatformOption";
import { WindowsMark, AppleMark, LinuxMark, DownloadIcon } from "./ConnectIcons";

const DESKTOP_PLATFORMS = [
  { id: "windows", label: "Windows" },
  { id: "macos", label: "macOS" },
  { id: "linux", label: "Linux" },
];

const ICONS = {
  windows: <WindowsMark size={18} />,
  macos: <AppleMark size={18} />,
  linux: <LinuxMark size={18} />,
};

export default function DesktopInstall() {
  const [selected, setSelected] = useState(DESKTOP_PLATFORMS[0].id);
  const current = DESKTOP_PLATFORMS.find((p) => p.id === selected);

  return (
    <>
      <span className={styles.kicker}>CHOOSE YOUR PLATFORM</span>
      <h3 className={styles.sectionTitle}>Get the Desktop app</h3>
      <p className={styles.sectionDesc}>
        Install PQ VPN on your work computer to start and manage the protected tunnel.
      </p>

      <div className={styles.platformList}>
        {DESKTOP_PLATFORMS.map((p) => (
          <PlatformOption
            key={p.id}
            label={p.label}
            icon={ICONS[p.id]}
            selected={selected === p.id}
            onSelect={() => setSelected(p.id)}
          />
        ))}
      </div>

      <button type="button" className={`${styles.btn} ${styles.btnPrimary}`}>
        <DownloadIcon size={16} />
        DOWNLOAD FOR {current.label.toUpperCase()}
      </button>
    </>
  );
}
